import * as React from 'react'

import getConfig from 'next/config'

import { BloomreachApi, CmsFooter, CmsHeader } from '@grandvision/bloomreach'
import { PageLayout } from '@grandvision/layout'
import { SearchIndex } from '@grandvision/search'

import { isMyAccountEnabled, isSearchEnabled } from '../util/feature-toggle'
const { publicRuntimeConfig } = getConfig()
const { indexes, productIndex } = publicRuntimeConfig.algolia

type Props = {
  children: React.ReactNode
  pageModel: BloomreachApi.PageModel
  asPath: string
  renderHeader?: boolean
  renderFooter?: boolean
  renderSiteNav?: boolean
  preview?: boolean
  isSolaris?: boolean
}

const handleSearch = (query: string, type: string) => {
  let searchRoute: string = ''
  const storeIndex = indexes && indexes.find((index: SearchIndex) => index.type === 'stores')

  switch (type) {
    case 'products':
      searchRoute = `${productIndex.targetPath}${encodeURIComponent(query)}`
      break
    case 'stores':
      searchRoute = `${storeIndex.targetPath}${encodeURIComponent(query)}`
      break
  }

  try {
    window.location.assign(searchRoute)
  } catch (error) {
    console.log(error)
  }
}

class Layout extends React.PureComponent<Props> {
  static defaultProps = {
    preview: false,
    isSolaris: false,
    renderHeader: true,
    renderFooter: true,
    renderSiteNav: true,
  }

  render() {
    const {
      children,
      pageModel,
      asPath,
      isSolaris = false,
      preview = false,
      renderHeader = true,
      renderFooter = true,
      renderSiteNav = true,
    } = this.props

    if (!pageModel) {
      return null
    }

    const header = renderHeader ? (
      <CmsHeader
        pageModel={pageModel}
        asPath={asPath}
        preview={preview}
        isMyAccountEnabled={isMyAccountEnabled}
        isSearchEnabled={isSearchEnabled}
        isSolaris={isSolaris}
        onSubmitSearch={handleSearch}
        renderSiteNav={renderSiteNav}
      />
    ) : (
      undefined
    )

    const footer = renderFooter ? <CmsFooter pageModel={pageModel} preview={preview} /> : undefined

    return (
      <PageLayout header={header} footer={footer} isSolaris={isSolaris} hasSiteNav={renderSiteNav}>
        {children}
      </PageLayout>
    )
  }
}

export default Layout
